import React, { Fragment } from "react";
import PropTypes from "prop-types";
import FilterForm from "./FilterForm";
import GridSector from "./GridSector";

class AppetiteSector extends React.Component {
    render() {
        const { toggleFilter, isFilterOpen } = this.props;
        return (
            <Fragment>
                <section className="wrapper filter__wrap--mob">
                    <button
                        className={`appetite__trigger appetite__trigger--mob`}
                        onClick={toggleFilter}
                    >
                        Filter &nbsp;
                        <i className="fas fa-chevron-down" />
                    </button>
                    <section
                        className={`appetite__wrap ${
                            isFilterOpen ? "is-active" : ""
                        }`}
                    >
                        {isFilterOpen && (
                            <FilterForm
                                {...this.props}
                                toggleFilter={toggleFilter}
                                formMode="Mob"
                            />
                        )}
                    </section>
                </section>
                <section className="appetite__grid">
                    <div className="accordion__content-wrapper container">
                        <section className="grid">
                            <GridSector {...this.props} />
                        </section>
                    </div>
                </section>
            </Fragment>
        );
    }
}

export default AppetiteSector;



// WEBPACK FOOTER //
// ./src/components/AppetiteSector.js